export const returnDirtyFieldsOnly = (dirtyFields: {}, data: {}): Record<string, any> => {
	const fieldNames = Object.keys(dirtyFields);

	const result = {};

	for (const fieldName of fieldNames) {
		if (data.hasOwnProperty(fieldName)) {
			result[fieldName] = data[fieldName];
		}
	}

	return result;
};
